import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { MarkupContainer } from "./MarkupRichText.styles";
export var MarkupRichText = function(param) {
    var content = param.content;
    if (!(content === null || content === void 0 ? void 0 : content.text)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(MarkupContainer, {
        dangerouslySetInnerHTML: {
            __html: content.text
        }
    });
};
